// extracted by mini-css-extract-plugin
module.exports = {"section":"text-header_section__62Pl3","heading":"text-header_heading__c8cMt","descriptionText":"text-header_descriptionText__KxCQ0"};